import { gql } from '@apollo/client'

export const GET_ORDER_BY_ID = gql`
  query GetOrderById($orderId: String!) {
    getOrderById(orderId: $orderId) {
      userId
      eventId
      quantity
      paid
      paymentProcessor
      paymentStatus
      paymentLastUpdated
      tickets {
        title
        email
        fullName
        discountCode
        ticketCode
        isAdditionalGuest
      }
    }
  }
`
